import slug from "slugify";

export default function slugify(input: string){
    if (!input) return "";
    return slug(input.toLowerCase(),{ replacement: "-", lower: true });
}

